module.exports = __webpack_public_path__ + "img/sam-smith.0a89038e.jpg";